export default "__VITE_ASSET__Bo9521dR__"